import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { NotificationType } from './Enums'
/**
* Class NotificationDto
*  Данные об уведомлении
*/
export class NotificationDto extends ActiveModel {

  /**
  * id
  * Идентификатор уведомления<br>  */
  @ActiveField(0)
  id: number = 0


/**
  * created
  * 
  */
  @ActiveField('')
  created: string = ''


/**
  * viewed
  * Время просмотра уведомления пользователем (через веб-интерфейс)<br>
  */
  @ActiveField(null)
  viewed: null | string = null


/**
  * processed
  * Время завершения обработки уведомления для получателя<br>
  */
  @ActiveField(null)
  processed: null | string = null


  /**
  * delivered
  * Доставлено ли уведомление до пользователя хотя бы через один из каналов распространения<br>  */
  @ActiveField(false)
  delivered: boolean = false


  /**
  * type
  * словарь значений публикуется под именем `Domain.Entities.Notifications.NotificationType`  *   * Тип уведомления<br>  *   * - `Order` Заказы  *   * Уведомление о заказе  * - `Product` Товары  *   * Уведомление о товаре  * - `ImageGeneration` AI-изображения  *   * Уведомление о генерации изображений  * - `CrmBroadcast` CRM-рассылки  *   * Рассылка по сегменту CRM (US-14)  * - `Exchange` Обмен данными  *   * Проблемы обмена с внешними системами (RFC-006, US-13)  *   */
  @ActiveField(NotificationType.ORDER)
  type: NotificationType = NotificationType.ORDER


/**
  * title
  * Заголовок<br>
  */
  @ActiveField('')
  title: string = ''


/**
  * content
  * Содержимое<br>
  */
  @ActiveField('')
  content: string = ''


  /**
  * contentIsHtml
  * Содержит ли Domain.Entities.Notifications.Notification.Content HTML-разметку<br>  */
  @ActiveField(false)
  contentIsHtml: boolean = false
}
